module.exports = __webpack_public_path__ + "images/category_lp/jewel/store_images/3_d12372eedcf0e0e6970c981323079505.png";